/* eslint-disable @typescript-eslint/no-use-before-define */
/* GLOBALS $ */
import intl from 'react-intl-universal'
import CONSTANTS from '~/constants'
import { hasPermission } from '../services/permission'

export default [
  '$rootScope',
  'toastr',
  'padlockService',
  '$timeout',
  'featureFlagService',
  lockKnockController,
]

function lockKnockController(
  $rootScope,
  toastr,
  padlockService,
  $timeout,
  featureFlagService
) {
  this.$onInit = () => {
    // Eric: TODO figure out why I m getting lockDetails when in the past I did not...
    this.lockDetails =
      (this.lockObj && this.lockObj.lockDetails) || this.lockObj
    this.story = this.storyObj
  }

  // TODO Get off global script
  this.canForce = () =>
    window.userRolesAuth &&
    window.userRolesAuth.story &&
    hasPermission(window.userRolesAuth.story.forceRelinquish)

  this.force = () => {
    let url = `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_API}/v1/knock/${this.story._id}?force`
    if ($rootScope.features.isEnabled('draftApiStateful')) {
      url = `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_API}/v2/story/${this.story._id}/takeover`
    }
    padlockService.force(this.story._id, url).then(
      (response) => {
        window.localStorage.showTakeoverSuccess = 'true'
        window.ignoreUnlock = true
        window.location.reload(true)
      },
      (response) => {
        toastr.error(intl.get('lockKnockButtons.force.error'))
        console.log('Error: User was not premitted to force unlock', response)
      }
    )
  }

  this.knock = async () => {
    let url = `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_API}/v1/knock/${this.story._id}`
    if ($rootScope.features.isEnabled('draftApiStateful')) {
      url = `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_API}/v2/story/${this.story._id}/lock/request?stateful=true`
    }
    this.knockDenied = false
    padlockService.knock(this.story._id, url).then(
      (response) => {
        window.localStorage.showTakeoverSuccess = 'true'
        window.location.reload(true)
      },
      (response) => {
        this.knockDenied = true
      }
    )
  }

  this.cancelKnock = () => padlockService.cancelKnock(this.story._id)
}
